import { AppForm } from './src/AppForm.js';

window.customElements.define('app-form', AppForm);
